var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSaturn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2015_2869)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.5 0C6.9 0 0.5 6.4 0.5 32C0.5 57.6 6.9 64 32.5 64C58.1 64 64.5 57.6 64.5 32C64.5 6.4 58.1 0 32.5 0Z",
    fill: "url(#paint0_linear_2015_2869)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.6336 41.5136C20.5778 41.6097 19.5771 41.6581 18.6422 41.6581C14.6482 41.6581 11.8887 40.7141 11.3078 38.9713C10.5937 36.7575 13.3206 33.7713 18.1073 30.8414C18.7026 23.3897 24.9866 17.4766 32.5846 17.4766C36.9676 17.4766 40.9133 19.4442 43.582 22.5398C44.5782 22.4563 45.5009 22.4145 46.382 22.4145C50.3759 22.4145 53.1354 23.2859 53.6437 25.1014C54.3229 27.2241 51.7011 30.1907 47.0697 33.058C46.5232 40.557 40.2169 46.5235 32.5846 46.5235C28.2269 46.5235 24.3015 44.5784 21.6336 41.5136ZM18.0723 32.5698C16.2108 33.7881 14.7042 34.9536 13.7768 36.0666C12.9054 37.0832 12.5423 38.0272 12.6875 38.5356C12.9054 39.407 14.8661 40.2058 18.6422 40.2058C19.263 40.2058 19.909 40.1868 20.5785 40.1471C19.0917 37.9673 18.1816 35.3668 18.0723 32.5698ZM45.5052 33.9796C45.0857 36.7111 43.8019 39.2275 41.807 41.2224C39.338 43.6914 36.0703 45.0711 32.5846 45.0711C29.1398 45.0711 25.9077 43.7235 23.4492 41.3086C26.819 40.8579 30.6394 39.975 34.618 38.6808C38.7381 37.3245 42.4615 35.6885 45.5052 33.9796ZM45.6532 32.2587C42.4762 34.1311 38.5407 35.8913 34.2549 37.3011C31.3502 38.2451 28.5181 38.9713 25.7586 39.4796C24.5512 39.7144 23.3903 39.8872 22.283 40.0052C20.4947 37.724 19.5135 34.9395 19.5135 32C19.5135 28.5144 20.8933 25.2466 23.3622 22.7776C25.8312 20.3086 29.0264 18.9289 32.5846 18.9289C36.0703 18.9289 39.338 20.3086 41.807 22.7776C44.276 25.2466 45.6557 28.5144 45.6557 32C45.6557 32.0864 45.6549 32.1726 45.6532 32.2587ZM47.0944 31.3678C47.4764 31.1197 47.8443 30.8704 48.1974 30.6203C51.4652 28.2965 52.627 26.4085 52.3366 25.5371C52.1187 24.6657 50.1581 23.8669 46.382 23.8669C45.8205 23.8669 45.2289 23.8669 44.6266 23.9057C46.0812 26.0583 46.9751 28.617 47.0944 31.3678ZM18.0637 31.7297L17.9886 32L18.0612 31.9952C18.0612 31.9065 18.0621 31.818 18.0637 31.7297Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2015_2869",
    x1: 0.5,
    y1: 64,
    x2: 64,
    y2: 64,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#506EE5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7037CD"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2015_2869"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaturn);
export default __webpack_public_path__ + "static/media/saturn.09d9da3845785bcffc2ad7c5744d8320.svg";
export { ForwardRef as ReactComponent };